import generateGameUrl from '../../utils/generateGameUrl';
import useGameUrlPayload from '../games/useGameUrlPayload';

const useMTTGameUrl = (tournamentId?: number) => {
  const { resolver, ...payload } = useGameUrlPayload();

  const linkConfig = {
    ...payload,
    gametype: 'tournament',
    endpoint: `6T.${tournamentId}`
  };

  return generateGameUrl(linkConfig, resolver);
};

export default useMTTGameUrl;
